var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#302C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1369 8.829C15.106 8.76654 15.0652 8.70954 15.0159 8.66025C13.9461 7.44862 11.7686 5.0625 11.7686 5.0625L9.00282 8.08763L6.20157 5.09119C6.20157 5.09119 3.99882 7.49813 2.91938 8.72269C2.77876 8.86106 2.77876 9.11081 2.90476 9.25819C3.46557 9.89719 6.22013 12.9347 6.22013 12.9347L8.99888 9.88931L11.7585 12.9375L15.0868 9.25538C15.0868 9.25538 15.1571 9.18225 15.1723 9.13331C15.2049 9.03206 15.1813 8.92181 15.1369 8.829ZM4.45388 9.16594C4.36388 9.05963 4.39426 8.89256 4.47807 8.79188C4.8302 8.39081 6.23926 6.87937 6.23926 6.87937L8.20238 8.96344L6.23588 11.1144C6.23588 11.1144 5.03213 9.82969 4.45388 9.16594ZM13.4471 9.23681C13.4057 9.30786 13.3575 9.37474 13.3031 9.4365L11.7788 11.0931L9.81001 9L11.7473 6.87656C11.7473 6.87656 12.8633 8.0325 13.3746 8.65406C13.4179 8.70806 13.4691 8.75925 13.491 8.82788C13.5377 8.96231 13.5079 9.11194 13.4466 9.23625",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.40f0c233ddec80ff00effcd1ed38ef62.svg";
export { ForwardRef as ReactComponent };